export const changenowApiKey = '7e7de5c280d2fa7f2b11a2f1b4e00c5113bc389f4b7394a4c7ae3804b9854c83';
